export class CheckOurCNameProgress
{
    constructor(
            public readonly checkId:string
        )
    {}
}
